import api from '@global-apis/config';

export interface ImpersonationParty {
  id: number;
  email: string;
  full_name: string;
  company_id: number | null;
  company_name: string | null;
}

export interface ImpersonationStart {
  access: string;
  session_id: number;
  expires_in: number;
  target: ImpersonationParty;
  actor: ImpersonationParty;
}

export interface ImpersonationStatus {
  impersonating: boolean;
  can_impersonate?: boolean;
  active?: boolean;
  session_id?: number;
  actor_email?: string;
  target?: ImpersonationParty;
}

const impersonationAPI = {
  start: async (user_id: number, reason: string) =>
    api.post<ImpersonationStart>('auth/impersonation/start/', { user_id, reason }),

  // Accepts either the impersonation token (ends the caller's own session) or the
  // operator's own token plus session_id.
  end: async (session_id?: number) => api.post('auth/impersonation/end/', session_id ? { session_id } : {}),

  status: async () => api.get<ImpersonationStatus>('auth/impersonation/status/')
};

export default impersonationAPI;
